<script>
  export default {
    name: 'autocomplete',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data() {
      return {
        search: null,
        searchText: '',
        results: [],
        isOpen: false,
      };
    },
    methods: {
      onChange() {
        this.isOpen = true;
        this.filterResults();
      },
      filterResults() {
        this.results = this.items.filter(item => item.text.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
      },
      onClickButton (event) {
        this.$emit('clicked', 'searchText');
      },
      setResult(result) {
        this.search = result.value;
        this.searchText = result.text;
        this.isOpen = false;
      },
    },
  }
</script>
<template>
  <div class="autocomplete">
    <input
       type="text"
       v-model="searchText"
       @input="onChange"
    />
      <ul
        v-show="isOpen"
        class="autocomplete-results"
      >
        <li
          v-for="(result, i) in results"
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result"
        >
          {{ result.text }}
        </li>
    </ul>
  </div>
</template>

<style>
  .autocomplete {
    position: relative;
    width: 130px;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }
</style>
